module.exports = __webpack_public_path__ + "static/media/rapidNaming-intro1.307847a1.mp3";